import { Game } from "../../Game";
import { Pool } from "../../Utils/Collections/Pool";
import { WrappedArray } from "../../Utils/Collections/WrapperArray";
import { ePhysicsObjects } from "../Stadium/Stadium";
import { Defender } from "./Defender";
import { DefenderManager } from "./DefenderManager";



export class DefenderCollision {
    private _container: pc.Entity;
    private _bodyPart: pc.Entity;

    private _headPartPool: Pool<pc.Entity>;
    private _headPartTemplate: pc.Entity;
    private _headPartActList: WrappedArray<pc.Entity>;

    private static readonly BODY_SIZE = new pc.Vec3(1, 1.5, 0.3);
    private static readonly HEAD_SIZE = new pc.Vec3(0.2, 0.28, 0.3);

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        /*let mat = new pc.StandardMaterial();

        mat.diffuse.set(1, 0, 0);
        mat.blendType = pc.BLEND_NORMAL;
        mat.opacity = 0.5;
        mat.update();*/

        this._container = new pc.Entity(ePhysicsObjects.defender);
        this._container.addComponent(pc.eCompomentType.rigidbody, {
            type: pc.BODYTYPE_STATIC,
            mass: 1,
            restitution: 0.2,
            friction: 0.5,
        });

        this._container.addComponent(pc.eCompomentType.collision, {
            type: pc.eCollisionVolumeType.compound,
        });

        Game.app.root.addChild(this._container);

        // Hlavni cast zdi
        this._bodyPart = new pc.Entity();
        /*this._bodyPart.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.box,
            material: mat,
            castShadows: false,
            receiveShadows: false,
        });*/
        this._bodyPart.addComponent(pc.eCompomentType.collision, {
            type: pc.eCollisionVolumeType.box,
        });
        this._bodyPart.setLocalPosition(0, DefenderCollision.BODY_SIZE.y / 2, -0.1);
        this._container.addChild(this._bodyPart);

        // Casti pro hlavy hracu
        this._headPartActList = new WrappedArray<pc.Entity>();
        this._headPartPool = new Pool<pc.Entity>(undefined, 1, true, (): pc.Entity => {
            let e: pc.Entity;

            if (!this._headPartTemplate) {
                this._headPartTemplate = new pc.Entity();
                /*this._headPartTemplate.addComponent(pc.eCompomentType.model, {
                    type: pc.eModelType.box,
                    material: mat,
                    castShadows: false,
                    receiveShadows: false,
                });*/
                this._headPartTemplate.setLocalScale(DefenderCollision.HEAD_SIZE.x, DefenderCollision.HEAD_SIZE.y, DefenderCollision.HEAD_SIZE.z);
                this._headPartTemplate.addComponent(pc.eCompomentType.collision, {
                    type: pc.eCollisionVolumeType.box,
                    halfExtents: new pc.Vec3(DefenderCollision.HEAD_SIZE.x / 2, DefenderCollision.HEAD_SIZE.y / 2, DefenderCollision.HEAD_SIZE.z / 2)
                });

                e = this._headPartTemplate;
            }
            else {
                e = this._headPartTemplate.clone() as pc.Entity;
            }

            this._container.addChild(e);

            return e;
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        this._container.enabled = false;

        // Uvolnit seznam aktivnich hlav
        this._headPartActList.forEach((e: pc.Entity): void => {
            e.enabled = false;
            this._headPartPool.returnItem(e);
        });
        this._headPartActList.clear(false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(x: number, z: number, rotation: number, defenderCnt: number): void {
        let w = Defender.SIZE.x * defenderCnt + DefenderManager.DEFENDERS_SPACING * (defenderCnt - 1);

        this._container.rigidbody.teleport(x, 0, z, 0, rotation, 0);
        this._bodyPart.setLocalScale(w, DefenderCollision.BODY_SIZE.y, DefenderCollision.BODY_SIZE.z);
        this._bodyPart.collision.halfExtents = new pc.Vec3(w / 2, DefenderCollision.BODY_SIZE.y / 2, DefenderCollision.BODY_SIZE.z / 2);

        // Hlavy
        for (let i = 0; i < defenderCnt; i++) {
            let head: pc.Entity;

            if (this._headPartActList.size > i) {
                head = this._headPartActList.getItemAtIndex(i);
            }
            else {
                head = this._headPartPool.getItem();
                this._headPartActList.add(head);
            }

            head.setLocalPosition((-w / 2) + i * (Defender.SIZE.x + DefenderManager.DEFENDERS_SPACING) + Defender.SIZE.x / 2, 1.645, -0.1);
            head.enabled = true;
        }

        // Uvolnit hlavy, ktere jsou navic
        while (this._headPartActList.size > defenderCnt) {
            let head = this._headPartActList.remove(true);

            head.enabled = false;
            this._headPartPool.returnItem(head);
        }

        this._container.enabled = true;
    }
}